export default "__VITE_ASSET__fda24fc9__"